// extracted by mini-css-extract-plugin
export default {"cards":"cards_cards__38yZj","card":"cards_card__vkhPw"};